import type { ApprovalMode } from '@ebalance/proto/bfftypes/v1/approval_flow_type_pb'
import type { AreaCode } from '@ebalance/proto/bfftypes/v1/area_pb'
import type { ApproverCandidate } from '@ebalance/proto/bffuser/v1/approval_flow_model_pb'

import type { MatrixModalControls } from '~/pages/AdminApprovalFlow/components/ApprovalMatrixModalHost'
import { MatrixModeCell } from '~/pages/AdminApprovalFlow/components/MatrixModeCell'
import type { ModeOption } from '~/pages/AdminApprovalFlow/components/matrixStyles'
import {
  type CellKey,
  type ProcessDef,
  makeNoSectionCellKey,
} from '~/pages/AdminApprovalFlow/constants/processMap'
import { isCellChanged } from '~/pages/AdminApprovalFlow/models/reducer'
import type { ProcessState } from '~/pages/AdminApprovalFlow/models/reducer'

export type MatrixRowProps = {
  processDef: ProcessDef
  processState: ProcessState
  /** 承認者候補リスト (= eauth の active member)。 欠落判定 (AC-APF-026d) に使う。 */
  candidates: ApproverCandidate[]
  modeOptions: ModeOption[]
  /** 「自動」セルの中身を描く (AC-APF-037)。 */
  renderAutoBidCell?: (area: AreaCode) => React.ReactNode
  /** 「保存」を押した後にエラー表示にするセル (AC-APF-071)。 */
  saveErrorKeys?: ReadonlySet<CellKey>
  onModeChange: (key: CellKey, mode: ApprovalMode) => void
  modalControls: MatrixModalControls
}

/** マトリクス本体の 1 行 (`<tr>`)。 エリアごとのセルを並べる (AC-APF-014)。 */
export const MatrixRow = ({
  processDef,
  processState,
  candidates,
  modeOptions,
  renderAutoBidCell,
  saveErrorKeys,
  onModeChange,
  modalControls: { openStage },
}: MatrixRowProps): React.ReactElement => (
  <tr>
    {processDef.areas.map((area) => {
      const key = makeNoSectionCellKey(processDef.businessProcess, area)
      return (
        <MatrixModeCell
          key={area}
          autoBidSummary={renderAutoBidCell?.(area)}
          candidates={candidates}
          cell={processState.cells.get(key)}
          changed={isCellChanged(
            processState.cells.get(key),
            processState.snapshot.cells.get(key),
          )}
          modeOptions={modeOptions}
          onModeChange={(mode) => onModeChange(key, mode)}
          onOpenStage={() => openStage({ cellKey: key, areaCode: area })}
          saveError={saveErrorKeys?.has(key) ?? false}
        />
      )
    })}
  </tr>
)
